import { Button } from '@storeblocks/button';
import { Icon } from '@storeblocks/icon';

import { StatusLayout } from '@storebrand-digital/bank-foundation-components';
import { getText } from '@storebrand-digital/fms-translations';

import { isWebView } from '@app/utils';

export default function ErrorPageView() {
  function handleGoToOverview() {
    window.location.href = getText('foundation.common.url.overview');
  }

  return (
    <StatusLayout
      figure={
        <Icon aria-label="cog-wheels">
          <img
            alt="cog-wheels"
            src="https://assets-t.storebrand.no/icons/rebrand/cog-wheels.svg"
            title="cog-wheels"
          />
        </Icon>
      }
      headingProps={{ htmlTag: 'h1' }}
      heading={getText('errorPage.heading')}
      description={
        <p className="font-body">{getText('errorPage.description')}</p>
      }
      actions={
        !isWebView && (
          <Button iconRight="arrow-right" onClick={handleGoToOverview}>
            {getText('errorPage.goToOverviewButton.text')}
          </Button>
        )
      }
    />
  );
}
